import React from 'react';
import Text from 'antd/lib/typography/Text';
import Dropdown from 'antd/lib/dropdown/dropdown';
import { CaretDownOutlined } from '@ant-design/icons';
import { OrgOverviewReleaseTypesFilter } from '@/types';
import { getNavDropdownMenuStyle } from '@/components/styles/globalStyles';
import { useSidebarColors } from '@/components/styles/themeMode';

const ORG_OVERVIEW_RELEASE_TYPES_LABELS: Record<OrgOverviewReleaseTypesFilter, string> = {
    [OrgOverviewReleaseTypesFilter.AllReleaseTypes]: 'All release types',
    [OrgOverviewReleaseTypesFilter.AllExceptHotfix]: 'All except hotfix',
    [OrgOverviewReleaseTypesFilter.HotfixOnly]: 'Hotfix only',
};

const ORG_OVERVIEW_RELEASE_TYPES_OPTIONS: Array<{
    value: OrgOverviewReleaseTypesFilter;
    label: string;
}> = [
    {
        value: OrgOverviewReleaseTypesFilter.AllReleaseTypes,
        label: ORG_OVERVIEW_RELEASE_TYPES_LABELS[OrgOverviewReleaseTypesFilter.AllReleaseTypes],
    },
    {
        value: OrgOverviewReleaseTypesFilter.AllExceptHotfix,
        label: ORG_OVERVIEW_RELEASE_TYPES_LABELS[OrgOverviewReleaseTypesFilter.AllExceptHotfix],
    },
    {
        value: OrgOverviewReleaseTypesFilter.HotfixOnly,
        label: ORG_OVERVIEW_RELEASE_TYPES_LABELS[OrgOverviewReleaseTypesFilter.HotfixOnly],
    },
];

interface ReleaseTypesSelectorProps {
    selectedValue?: OrgOverviewReleaseTypesFilter;
    onChange: (value?: OrgOverviewReleaseTypesFilter) => void;
}

export const OrgOverviewReleaseTypesSelector: React.FC<ReleaseTypesSelectorProps> = ({ selectedValue, onChange }) => {
    const sidebarColors = useSidebarColors();
    const selectedOption =
        ORG_OVERVIEW_RELEASE_TYPES_OPTIONS.find((option) => option.value === selectedValue)?.label ??
        ORG_OVERVIEW_RELEASE_TYPES_LABELS[OrgOverviewReleaseTypesFilter.AllReleaseTypes];

    return (
        <div
            style={{
                marginBottom: 16,
            }}
        >
            <Dropdown
                menu={{
                    items: ORG_OVERVIEW_RELEASE_TYPES_OPTIONS.map((option) => ({
                        key: option.value,
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '4px 0px',
                                    borderRadius: 'inherit',
                                }}
                            >
                                <Text style={{ color: sidebarColors.text, fontSize: 14 }}>{option.label}</Text>
                            </div>
                        ),
                    })),
                    onClick: (item) => onChange(item.key as OrgOverviewReleaseTypesFilter),
                    style: getNavDropdownMenuStyle(sidebarColors),
                }}
                trigger={['click']}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        padding: '5px 12px',
                        border: `1px solid ${sidebarColors.border}`,
                        borderRadius: 4,
                        backgroundColor: sidebarColors.dropdownBg,
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text style={{ color: sidebarColors.text, fontSize: 14 }}>{selectedOption}</Text>
                    </div>
                    <CaretDownOutlined style={{ color: sidebarColors.textMuted, fontSize: 16, marginLeft: 12 }} />
                </div>
            </Dropdown>
        </div>
    );
};
